import type { ComponentProps } from 'react';

const CheckboxIcon = (
  props: ComponentProps<'svg'> & {
    isChecked?: boolean;
  }
) => {
  if (!props.isChecked) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        {...props}
      >
        <rect
          x="0.416667"
          y="0.416667"
          width="15.1667"
          height="15.1667"
          rx="2.91667"
          stroke="#8C98AB"
          stroke-width="0.833333"
        />
      </svg>
    );
  }
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="16" height="16" rx="3.33333" fill="#EE4F5E" />
      <path
        d="M4 7.75627L6.82353 10.6654L12 5.33203"
        stroke="white"
        stroke-width="1.66667"
      />
    </svg>
  );
};

export default CheckboxIcon;
